import { toIsoDateLocal } from './formatters';

const FRIDAY = 5;
const DAYS_PER_WEEK = 7;
const WEEKEND_NIGHTS = 2;

export interface TripDateRange {
  checkin: string;
  checkout: string;
}

function addDays(date: Date, days: number): Date {
  const shifted = new Date(date);
  shifted.setDate(date.getDate() + days);
  return shifted;
}

/** Next Friday to Sunday; on a Friday, the following Friday. */
export function thisWeekendRange(today: Date): TripDateRange {
  const daysToFriday = (FRIDAY - today.getDay() + DAYS_PER_WEEK) % DAYS_PER_WEEK || DAYS_PER_WEEK;
  const friday = addDays(today, daysToFriday);
  return {
    checkin: toIsoDateLocal(friday),
    checkout: toIsoDateLocal(addDays(friday, WEEKEND_NIGHTS)),
  };
}

/** Seven nights starting seven days from today. */
export function aWeekRange(today: Date): TripDateRange {
  const start = addDays(today, DAYS_PER_WEEK);
  return {
    checkin: toIsoDateLocal(start),
    checkout: toIsoDateLocal(addDays(start, DAYS_PER_WEEK)),
  };
}
